import { useMemo } from "react";
import { Link } from "react-router";
import JoinLink from "@core/layouts/header/components/common/JoinLink";
import { useUiStore } from "@core/stores/uiStore";
import { ID_DOMAIN } from "@core/constants/service";
import { cn } from "@core/utils/domUtil";
import type { networkType } from "@core/types/uiType";

const linkData = {
  ncfz: {
    findId: () => "/account/find-id",
    findPassword: () => "/account/find-password",
  },
  plaync: {
    findId: (network: networkType) => `${ID_DOMAIN[network]}/recovery/account`,
    findPassword: (network: networkType) => `${ID_DOMAIN[network]}/recovery/password`,
  },
};

const itemClassName = cn(
  "relative text-md",
  "first:before:hidden first:pl-0 pl-[8px] before:w-[1px] before:h-[8px] before:bg-black/30 before:absolute before:top-1/2 before:-translate-y-1/2 before:left-0",
);

export default function LinkUtil({ userType }: { userType: "ncfz" | "plaync" }) {
  const network = useUiStore((state) => state.network);
  const link = useMemo(() => linkData[userType], [userType]);

  return (
    <ul className="flex justify-between lg:mt-[20px]">
      <li className={itemClassName}>
        <Link to={link.findId(network)}>아이디 찾기</Link>
      </li>
      <li className={cn(itemClassName, "shrink-0")}>
        <Link to={link.findPassword(network)}>비밀번호 찾기</Link>
      </li>
      <li className={itemClassName}>
        <JoinLink variant="text" size="small" />
      </li>
    </ul>
  );
}
